export const LOGIN = "LOGIN";
export const CLIENT_LOGIN = "CLIENT_LOGIN";
export const LOGOUT = "LOGOUT";
export const CLIENT_LOGOUT = "CLIENT_LOGOUT";
